export default {
  index: [
    {
      path: '/type',
      component: resolve => require(['./productsIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/type/_router.js